<template>
  <div class="grid-view">
    <div
      class="main-content"
      type="primary"
    >
      <search-item
        config-module="410015203"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-button v-show="$checkPermission(['button_BillOverseasSCenter_writeOffs'])" type="primary" no="2" @click="overseaBtnEventHandler()">{{ $t('CargoMsg.Cargo_WriteOff') }}</el-button>
          <el-button v-show="$checkPermission(['button_BillOverseasSCenter_billOverseasReturn'])" type="primary" no="3" @click="toReturn()">{{ $t('CargoMsg.Cargo_Return') }}</el-button>
          <el-button type="primary" no="4" @click="onPrint()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          <el-upload
            v-show="$checkPermission(['button_BillOverseasSCenter_importAndQuery'])"
            :action="URL.act.billing.importAndQueryBilling"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="importSuccess"
            style="display: inline-block; margin-left: 5px"
            no="5"
          >
            <el-button type="primary" no="6">{{ $t('CargoMsg.Cargo_ImportAndQueryOfBillNumber') }}</el-button>
          </el-upload>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015203"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="410015203"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :ctx="templateSelectorDialog.ctx"
    />
    <!-- 销账 or 对冲销账 -->
    <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :location="location" :visible.sync="writeOffDialog.visible" :title="title" :params="writeOffDialog.params" :properties="this.properties" @writeoffSuccessHandler="writeoffSuccessHandler" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import { queryBillOverseasAdv, batchUpdateStates } from '@/api/clearing/billingNative'
import StrUtils from '@/utils/StrUtils'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import QueryBillOverseasAcceptCondition from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillOverseasAcceptCondition'
import BillOverseasSCenterGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSCenterGrid'
import moment from 'moment'
import WriteOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import URL from '@/api/urlTranslator'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getBankAccountList } from '@/api/bankAccount'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { recordSelectedStatus } from '@/utils/agGrid'
import {
  LOG_OVERSEAS_SETTLEMENT_CENTER
} from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'NewBillOverseasSAcceptView',
  components: { WriteOffDialog, BillOverseasSCenterGrid, QueryBillOverseasAcceptCondition, CargoTemplateSelectDialog, AmountSumMaster, searchItem },
  data() {
    return {
      gridParams: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', colId: 'billingNo', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_CounterpartySBillingNo'), colId: 'counterPartyBillingNo', field: 'counterPartyBillingNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNoInBill'), colId: 'jobNo', field: 'jobNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'jobOp', field: 'jobOp',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountStatementNo'), colId: 'billingGroupBillingNo', field: 'billingGroupBillingNo'
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', colId: 'settlementAgentId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_BillDate'), field: 'inputDate', colId: 'inputDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: 'MBL', field: 'jobMbl', colId: 'jobMbl', width: 200 },
        { headerName: 'ETD', field: 'jobEtd', colId: 'jobEtd', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA', field: 'jobEta', colId: 'jobEta', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATD', field: 'jobAtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATA', field: 'jobAta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'jobBusinessDate', colId: 'jobBusinessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'jobPono', colId: 'jobPono', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_CreditAmount2'), field: 'amountCredit', colId: 'amountCredit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DebitAmount2'), field: 'amountDebit', colId: 'amountDebit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_CreditNotWrittenOff'), field: 'amountCreditUnverify', colId: 'amountCreditUnverify', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_DebitNotWrittenOff'), field: 'amountDebitUnverify', colId: 'amountDebitUnverify', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_FinancialDate'), field: 'financialDate', colId: 'financialDate', width: 200,
          valueFormatter: (params) => {
            return this.bussDateLabFun(params)
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'realClearingState', colId: 'realClearingState', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_BillStatus'), field: 'state', colId: 'state', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getBillState(Number(params.value))
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', colId: 'remark', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_OurBank'),
          field: 'bankAccountChineseName',
          colId: 'bankAccountChineseName',
          width: 200
        }
      ],
      URL,
      fullscreenLoading: null,
      isAdvancedQuery: false, // 是否为高级查询
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      filterJson: {},
      writeOffDialog: {
        visible: false,
        params: {}
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'BILLING',
        data: {},
        ctx: null,
        printedCallback: null
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        }
      },
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: null, // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: true, // 是否海外销账
        defaultCurrency: 'USD', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: false, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: true, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 3, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 3, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [] // 费用所包含的币种
      },
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      location: LOG_OVERSEAS_SETTLEMENT_CENTER.code
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    }
  },
  async created() {
    await this.initCustomSearchItems()
    await cache.load(cacheName.CONFIG)
    this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
  },
  methods: {
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      const condition = AdvancedSearchOption.getOption('merge', this.filterJson.conditions)
      if (condition && condition.value && !AdvancedSearchOption.hasField('billing.ACCOUNTID', this.filterJson.conditions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_RECEIVED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      if (this.filterJson.conditions && this.filterJson.conditions.length > 0) {
        if (AdvancedSearchOption.hasField('billing.BRANCH_ID', this.filterJson.conditions)) {
          const option = AdvancedSearchOption.getOption('billing.BRANCH_ID', this.filterJson.conditions)
          this.filterJson.branchId = option.value
          AdvancedSearchOption.removeOption('billing.BRANCH_ID', this.filterJson.conditions)
        }
      }
      this.filterJson.isAdvancedQuery = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    toSimpleQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.jobNo = data
        this.filter.pageNum = 1
      }
      this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filter.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_RECEIVED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filter.conditions.push(option.formatObj2Json())
      }
      this.filter.isAdvancedQuery = false
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      this.rowData = []
      for (const data of res.data.list) {
        if (data) {
          this.rowData.push(data)
        }
      }
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.loadingEnd()
      selectedStatus.revert()
    },
    bussDateLabFun(params) {
      const bill = params.data
      if (!bill || !bill.charge) { return '' }
      if (bill.charge.length > 0) {
        return ColumnUtils.dateLabelFunc(bill.charge[0].accountingDate)
      }
      return ''
    },
    importSuccess(res) {
      if (res.data.length === 0) {
        this.$message.success(this.$t('CargoMsg.noRowsToShow'))
        return
      }
      const option = new AdvancedSearchOption('FIELD_MULTI_TEXT', 'billing.BILLINGNO', res.data, AdvancedSearchConsts.OPERATOR_BATCH.code).formatObj2Json()
      const data = []
      data.push(option)
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      const condition = AdvancedSearchOption.getOption('merge', this.filterJson.conditions)
      if (condition && condition.value && !AdvancedSearchOption.hasField('billing.ACCOUNTID', this.filterJson.conditions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_RECEIVED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      if (this.filterJson.conditions && this.filterJson.conditions.length > 0) {
        if (AdvancedSearchOption.hasField('billing.BRANCH_ID', this.filterJson.conditions)) {
          const option = AdvancedSearchOption.getOption('billing.BRANCH_ID', this.filterJson.conditions)
          this.filterJson.branchId = option.value
          AdvancedSearchOption.removeOption('billing.BRANCH_ID', this.filterJson.conditions)
        }
      }
      this.filterJson.isAdvancedQuery = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filterJson).then(result => {
        if (result.data.list.length === 0) {
          this.$message.success(this.$t('CargoMsg.noRowsToShow'))
          return
        }
        this.handleQueryData(result)
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
    },
    toReturn() {
      this.updateState()
    },
    async overseaBtnEventHandler() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (StrUtils.isEmpty(billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff'))
          return
        }
        if (this.chargeIsPadOff(billing)) {
          const msg = StrUtils.substitute(this.$t('CargoMsg.Cargo_BillsHasBeenPaidInFull'), billing.billingNo)
          this.$message.warning(msg)
          return
        }
        if (typeof billing.company !== 'object') {
          billing.company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', billing.accountId) || null
        }
      }
      let company = {}
      const accountID = selectRows[0].accountId
      let isDifferent = false
      const companyKeys = []
      let hasNoneGlobal = false
      let cancelClick = false
      if (selectRows.length > 1) {
        for (const b of selectRows) {
          if (b.accountId !== accountID) {
            isDifferent = true
          }
          if (b.company.isGlobal) {
            companyKeys.push(b.company.key)
            company = b.company
          } else {
            if (b.company.globalAccount) {
              companyKeys.push(b.company.globalAccount.key)
            } else {
              hasNoneGlobal = true
            }
          }
        }
        // 结算对象不一致
        if (isDifferent) {
          let isDifferentAndNoneGlobal = false
          // 没有归并
          if (hasNoneGlobal) {
            isDifferentAndNoneGlobal = true
          }
          const key = companyKeys[0]
          if (this.hasKey(companyKeys, key)) {
            isDifferentAndNoneGlobal = true
          }
          if (isDifferentAndNoneGlobal) {
            const isDifferentSettlementAgent = !(selectRows[0].settlementAgentId && ClearingUtils.isSameSettlementAgent(selectRows))
            if (isDifferentSettlementAgent) {
              // CARGO-28207，海外结算中心 无法使用合并多个结算单位一起核销功能
              if (this.properties.writeoffByDifferentAccount) {
                await this.$confirm(this.$t('CargoMsg.Cargo_FIDSEC'), this.$t('CargoMsg.Cargo_Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                  type: 'warning'
                }).then(() => {
                  this.properties.accountId = 0
                }).catch(() => {
                  cancelClick = true
                  return
                })
              } else {
                this.$message.warning(this.$t('CargoMsg.Cargo_SPIANA_DiffSettlementAgent'))
                return
              }
            }
          }
          if (!company) {
            company = selectRows[0].company.globalAccount
          }
        } else {
          company = selectRows[0].company
        }
      } else {
        company = selectRows[0].company
      }
      if (!cancelClick) this.writeoff()
    },
    writeoff() {
      if (!this.checking()) {
        return
      }
      const keys = []
      for (const item of this.selectedRows) {
        keys.push(item.uuid)
      }
      const properties = this.properties
      const requestBody = { 'keys': keys, 'classType': 'billing', 'isOversea': true }
      this.loading = getLoading()
      getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
        this.properties.allEntities = []
        this.properties.selectedEntities = this.selectedRows
        this.properties.allEntities.push(...this.properties.entities)
        properties.isAr = this.getBillingAr()
        this.properties.currencys = []
        for (const charge of this.properties.allEntities) {
          if (this.properties.currencys.indexOf(charge.currency) === -1) {
            this.properties.currencys.push(charge.currency)
          }
        }
        this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
        this.writeOffDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    hasKey(companyKeys, key) {
      for (const item of companyKeys) {
        if (item !== key) {
          return true
        }
      }
      return false
    },
    writeoffSuccessHandler() {
      this.toQuery()
    },
    getBillingAr() {
      let t = 0
      let t1 = 0
      for (const b of this.selectedRows) {
        if (b.ar) {
          t += b.amount
        } else {
          t1 += b.amount
        }
      }
      return t > t1
    },
    // 退回,接受
    updateState() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (this.getBillChargeAmount(billing) > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillsAlreadyWriteOffFee', [billing.billingNo]))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        // 退回到已打印状态
        this.fullscreenLoading = getLoading()
        batchUpdateStates(selectRows, { state: 2 }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.gridOptions.api.updateRowData({ 'remove': selectRows })
          this.loadingEnd()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    // 判断当前账单是否全部核销
    getBillChargeAmount(bill) {
      let amount = 0
      for (const charge of bill.charge) {
        charge.clearRemarks = ''
        amount = this.getChargeClearHistory(charge.clearHistory)
      }
      return amount
    },
    chargeIsPadOff(bill) {
      for (const charge of bill.charge) {
        const verifiedAmount = this.getChargeClearHistory(charge.clearHistory)
        if (charge.amount.toFixed(2) !== verifiedAmount.toFixed(2)) {
          return false
        }
      }
      return true
    },
    getChargeClearHistory(historys) {
      let chargeAmount = 0
      if (!historys) {
        return chargeAmount
      }
      for (const clearHistory of historys) {
        if (clearHistory.ar) {
          chargeAmount += clearHistory.clearamount / clearHistory.clearRate // (clearHistory.clearamount * RateUtil.getForeignExchangeRateByDate(clearHistory.chargeCurrency,clearHistory.actualCurrency,new Date()));
        } else {
          chargeAmount -= clearHistory.clearamount / clearHistory.clearRate // (clearHistory.clearamount * RateUtil.getForeignExchangeRateByDate(clearHistory.chargeCurrency,clearHistory.actualCurrency,new Date()));
        }
      }
      return Math.abs(chargeAmount)
    },
    // resetSearch() {
    //   this.$refs['queryBillOverseasAcceptCondition'].resetSearch()
    // },
    // 参照 ActualAmount.checkBillPaymentApproved --前端实现
    checking() {
      const payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      if (payAfterPayApply === 1 || payAfterPayApply === 2 || payAfterPayApply === 3) {
        if (payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.selectedRows)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const row of this.selectedRows) {
          if (row.charge && row.charge.length > 0) {
            for (const charge of row.charge) {
              if (payAfterPayApply === 3) {
                if (!charge.receivable && (charge.billingPaymentUuid && [0, 1, 2, 6].includes(charge.billPaymentState))) {
                  this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
                  return false
                }
              } else {
                if (!charge.receivable && (StrUtils.isEmpty(charge.billingPaymentUuid) || [0, 1, 2, 6].includes(charge.billPaymentState))) {
                  this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail'))
                  return false
                }
              }
            }
          }
        }
      }
      return true
    },
    checkAllReceivable(rows) {
      for (const row of rows) {
        if (!row.ar) {
          return false
        }
      }
      return true
    },
    onPrint() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      const keyList = []
      for (const billing of selectRows) {
        keyList.push(billing.key)
      }
      const params = {
        BILLING_UUID_LIST: keyList,
        BILLING_UUID: keyList
      }
      // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
      if (selectRows.length === 1) {
        params['billingNo'] = selectRows[0].billingNo
        if (!StrUtils.isEmpty(selectRows[0].jobNo)) {
          params['jobNo'] = selectRows[0].jobNo
        }
      }
      this.templateSelectorDialog.visible = true
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.data = params
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      // 银行名称和银行账号要去重
      const bankList = []
      const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
      if (res.data && res.data.length > 0) {
        for (const item of res.data) {
          bankList.push(item)
        }
      }
      // 我方银行名称
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.action = 2
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemValue = []
      searchField.itemLabel = 'CargoMsg.Cargo_OurBank'
      searchField.itemName = 'billing.BANK_ACCOUNT_ID'
      searchField.headers = [this.$t('Clearing.BankName')]
      searchField.fields = ['bankChineseName']
      searchField.tagName = 'bankChineseName'
      searchField.tagValue = 'accountId'
      searchField.dataCacheKey = 'static_data_BankAccount'
      searchField.dataProvider = bankList
      defaultSearchFields.push(searchField.formatObj2Json())
      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
